import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

const TermsAndConditionsText = ({ order }) => {
  const intl = useIntl();

  return (
    <span className="d-block font-small-2 text-center">
      <FormattedMessage
        id="checkoutButtonSubText"
        values={{
          total: intl.formatNumber(order?.total, {
            format: 'priceCurrency',
          }),
          privacy_link: (text) => (
            <a
              href="https://servier.bar/datenschutz/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {text}
            </a>
          ),
          agb_link: (text) => (
            <a
              href="https://servier.bar/agb/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {text}
            </a>
          ),
        }}
      />
    </span>
  );
};

export default TermsAndConditionsText;
